// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
    'dirty': true,
    'raw': 'v4.8.12-655-g6be14bf042-dirty',
    'hash': 'g6be14bf042',
    'distance': 655,
    'tag': 'v4.8.12',
    'semver': {
        'options': {
            'loose': false,
            'includePrerelease': false,
        },
        'loose': false,
        'raw': 'v4.8.12',
        'major': 4,
        'minor': 8,
        'patch': 12,
        'prerelease': [],
        'build': [],
        'version': '4.8.12',
    },
    'suffix': '655-g6be14bf042-dirty',
    'semverString': '4.8.12+655.g6be14bf042',
    'version': '0.0.0',
};
